"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _DropDown = _interopRequireWildcard(require("../DropDown"));

var _humanTime = require("../humanTime");

var _momentPropType = _interopRequireDefault(require("../_utils/momentPropType"));

require("./calendarItem.sass");

var _CalendarContext = _interopRequireDefault(require("./CalendarContext"));

var _constants = require("./constants");

var SHADOW_NUMS = 2;

var CalendarItem =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(CalendarItem, _Component);

  function CalendarItem() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, CalendarItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(CalendarItem)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "createHandleIconClick", function (onIconClick) {
      return function (e) {
        e.stopPropagation();
        e.preventDefault();
        onIconClick();
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderShadows", function () {
      var collectiveNums = _this.props.collectiveNums;
      collectiveNums = collectiveNums >= SHADOW_NUMS ? SHADOW_NUMS : collectiveNums;
      var shadows = Array.from(Array(collectiveNums));
      return shadows.map(function (val, i) {
        return _react.default.createElement("div", {
          key: i,
          className: "calendar-item-box-collectiveShadow"
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderTime", function () {
      var date = _this.props.date;
      var view = _this.context.view;

      switch (view) {
        case _constants.YEAR:
          return (0, _moment.default)(date).format('ddd D');

        case _constants.MONTH:
        default:
          return (0, _humanTime.humanTime)(date).time;
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderIcons", function () {
      var icons = _this.props.icons;

      if (!icons || !icons.length) {
        return null;
      }

      return icons.map(function (_ref, i) {
        var Icon = _ref.Icon,
            onIconClick = _ref.onIconClick;
        return _react.default.createElement("div", {
          key: "icon-".concat(i),
          className: "calendar-item-icon"
        }, _react.default.createElement(Icon, {
          onClick: _this.createHandleIconClick(onIconClick)
        }));
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onClick", function (e) {
      e.preventDefault();
      _this.props.onClick && _this.props.onClick(e);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getTrigger", function () {
      var _this$props = _this.props,
          customTrigger = _this$props.customTrigger,
          color = _this$props.color,
          title = _this$props.title;

      if (customTrigger) {
        return customTrigger;
      }

      return _react.default.createElement("div", {
        className: "calendar-item-box",
        style: {
          backgroundColor: color
        }
      }, _this.isCollective && _this.renderShadows(), _react.default.createElement("div", {
        className: "calendar-item-content"
      }, _react.default.createElement("span", {
        className: "calendar-item-time"
      }, _this.renderTime()), _react.default.createElement("span", {
        className: "calendar-item-title"
      }, title), _this.renderIcons()));
    });
    return _this;
  }

  (0, _createClass2.default)(CalendarItem, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          children = _this$props2.children,
          onClick = _this$props2.onClick;
      var trigger = this.getTrigger();

      if (!children) {
        return _react.default.createElement("div", {
          className: (0, _classnames.default)('calendar-item', className, {
            'calendar-item--clickable': !!onClick
          }),
          onClick: this.onClick
        }, trigger);
      }

      return _react.default.createElement(_DropDown.default, {
        className: (0, _classnames.default)('calendar-item', 'calendar-item--interactive', className),
        trigger: trigger,
        align: _DropDown.ALIGN_TOP,
        children: children
      });
    }
  }, {
    key: "isCollective",
    get: function get() {
      return !!this.props.collectiveNums;
    }
  }]);
  return CalendarItem;
}(_react.Component);

exports.default = CalendarItem;
(0, _defineProperty2.default)(CalendarItem, "contextType", _CalendarContext.default);
CalendarItem.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node,
  title: _propTypes.default.node,
  color: _propTypes.default.string,
  date: _propTypes.default.oneOfType([_propTypes.default.instanceOf(Date), _momentPropType.default]).isRequired,
  icons: _propTypes.default.arrayOf(_propTypes.default.exact({
    Icon: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.instanceOf(_react.Component)]).isRequired,
    onIconClick: _propTypes.default.func
  })),
  collectiveNums: _propTypes.default.number,
  onClick: _propTypes.default.func,
  customTrigger: _propTypes.default.node
} : {};